import React from "react";
import Navbar from "../../../components/Navbar";
import SideNavbar from "../../../components/SideNavbar";
import CallStatus from "../../../components/CallStatus";
import CallDistribution from "../../../components/CallDistribution";
import ConversionRatio from "../../../components/ConversionRatio";
import LeadByStatus from "../../../components/LeadByStatus";
import LeadByStage from "../../../components/LeadByStage";
import { useAppSelector } from "../../../redux/store";

const CallCrm: React.FC = () => {
  const isCollapsed = useAppSelector(state => state.sidebar.isCollapsed);

  return (
    <div className="min-h-screen bg-gray-200">
      {/* <div className="fixed top-0 left-0 w-full z-10">
        <Navbar />
      </div> */}
      <div className="fixed top-16 left-0 h-full z-10">
        <SideNavbar />
      </div>
      <div className={`${isCollapsed ? 'ml-[70px]' : 'ml-[290px]'} mt-[109px] p-8 transition-all duration-300`}>
        <div className="grid grid-cols-3 gap-6">
          <div className="col-span-2 bg-white p-6 rounded-3xl shadow-md">
            <CallStatus />
          </div>
          <div className="bg-white p-6 rounded-3xl shadow-md">
            <CallDistribution />
          </div>
          <div className="bg-white p-6 rounded-3xl shadow-md">
            <LeadByStatus />
          </div>
          <div className="bg-white p-6 rounded-3xl shadow-md">
            <LeadByStage />
          </div>
          <div className="bg-white p-6 rounded-3xl shadow-md">
            <ConversionRatio />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CallCrm;
